import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_headed/resources/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/resources/featured" />;
}
